import { graphql } from "@/gql";

export const generateInvoicesForContactMutation = graphql(`
  mutation GenerateInvoicesForContact($contactId: ID!, $asDraft: Boolean) {
    generateInvoicesForContact(contactId: $contactId, asDraft: $asDraft) {
      id
      reference
      status
      amount_inc_tax
      invoice_date
      due_date
    }
  }
`);
